module.exports = __webpack_public_path__ + "static/media/2.f502d5b7.png";